import { Button, Typography } from "@mui/material";
import { useParams } from "react-router";
import StyledPage from "@entrilia/shared/components/infoPage/StyledPage";
import { useUnsavedReportContext } from "../../contexts/UnsavedReportContext";
import ReportNotFoundOrAccessForbiddenPageIcon from "../../../../../common/ReportNotFoundOrAccessForbiddenPageIcon";

interface Props {
  getReportsUrl?: (clientCode: string) => string;
  reason?: string;
}

const ReportNotFoundOrAccessForbidden = ({ getReportsUrl, reason }: Props) => {
  const { client } = useParams<{ client: string }>();
  const unsavedReport = useUnsavedReportContext();

  return (
    <StyledPage>
      <ReportNotFoundOrAccessForbiddenPageIcon sx={{ height: 74, width: 55 }} />
      <Typography variant="h6">
        {reason ? "The report cannot be opened." : "The report was not found or you do not have access to it."}
      </Typography>
      {reason && <Typography color="textSecondary">{reason}</Typography>}
      {unsavedReport && (
        <Button variant="outlined" color="secondary" onClick={unsavedReport.onClose}>
          Close
        </Button>
      )}
      {!unsavedReport && client && getReportsUrl && (
        <Button variant="outlined" color="secondary" onClick={() => (window.location.href = getReportsUrl(client))}>
          Back to Report list
        </Button>
      )}
    </StyledPage>
  );
};

export default ReportNotFoundOrAccessForbidden;
